import { getConsumerFor } from "./consumer";
import {Subscription} from "@rails/actioncable";

export class CampaignChannelSubscription {
  public subscription: Subscription;
  private readonly campaignId: number;

  constructor(campaignId: number, { received, connected = undefined, disconnected = undefined }) {
    this.campaignId = campaignId;
    this.subscription = getConsumerFor(null).subscriptions.create(
      {
        channel: "CampaignChannel",
        id: this.campaignId,
      },
      {
        received,
        connected,
        disconnected,
      }
    );
  }

  unsubscribe() {
    this.subscription.unsubscribe();
  }
}